import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, Input, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren, ViewContainerRef } from "@angular/core";

import { Subscription } from "rxjs";
import { CommonModule, NgTemplateOutlet } from "@angular/common";
import { GlassLayerService } from "./GlassLayerService";


@Component({
  selector: 'dl-app-glass-layer',
  standalone: true,
  imports: [CommonModule],
  template: ` 
    <!-- L'unico Layer Overlay -->
    <div 
      class="dl-app-glass-overlay"
      [ngClass]="{ 'dl-app-active-layer': isActive && blocking }"
      (click)="closeIfActive($event)"
    >
      <!-- Questo ng-template è l'unico "buco" (VCR) -->
      <div class="dl-app-layer-content-container">
        <ng-template #glassLayerVCR></ng-template>
      </div>
    </div> 
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GlassLayerComponent implements OnInit, OnDestroy {

  @Input() layerName!: string;
  @Input() blocking = false;

  // Riferimento al singolo ViewContainerRef
  @ViewChild('glassLayerVCR', { read: ViewContainerRef, static: true })
  singleLayerVCR!: ViewContainerRef;

  private layerSubscription!: Subscription;

  constructor(private layerService: GlassLayerService, private cdr: ChangeDetectorRef) {

  }

  public isActive: boolean = false; // Stato per la classe CSS del background

  private get layer() {
    return this.layerService.getLayer(this.layerName);
  }

  ngOnInit(): void {
    // Sottoscriviti allo stato di attivazione del Service
    this.layerSubscription = this.layer.isActive$.subscribe(isActive => {
      this.isActive = isActive;
      this.cdr.detectChanges(); // Aggiorna la vista quando lo stato cambia
    });
  }

  ngAfterViewInit(): void {
    // Registra il VCR nel Service
    this.layer.registerContainer(this.singleLayerVCR);
  }

  ngOnDestroy(): void {
    this.layerSubscription.unsubscribe();
  }

  // --- ESEMPIO DI UTILIZZO (Componente B) ---

  /*
  openModal(): void {
    // Chiamata ora agnostica ai dati
    this.layer.openComponent(DynamicContentComponent);
  }
*/

  closeIfActive(event: Event): void {
    if (!this.blocking) {
      return;
    }

    // Logica per chiudere se si clicca sullo sfondo (overlay) e non sul contenuto
    const target = event.target as HTMLElement;
    // Controlla se il click è avvenuto esattamente sull'overlay e se il layer è attivo
    if (this.isActive && target.classList.contains('dl-app-glass-overlay')) {
      this.layer.closeComponent();
    }
  }
}